import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import styles from './styles/RegisterPage.module.css';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const RegisterPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const inviteCodeFromUrl = searchParams.get("invite_code");
  const emailFromUrl = searchParams.get("email") ? 
    decodeURIComponent(searchParams.get("email")!).replace(/ /g, '+') : 
    null;

  const [inviteCode, setInviteCode] = useState(inviteCodeFromUrl || "");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState(emailFromUrl || "");
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();

    if (!username || !password || (!inviteCodeFromUrl && !inviteCode)) {
      setErrorMessage("All fields are required.");
      return;
    }

    try {
      const payload = {
        username,
        password,
        email,
        ...(inviteCode && { invite_code: inviteCode }),
      };

      const response = await fetch(`${API_BASE_URL}/api/auth/register`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        navigate("/login");
      } else {
        const errorData = await response.json();
        setErrorMessage(errorData.error || "Registration failed.");
      }
    } catch (error) {
      setErrorMessage("An unexpected error occurred. Please try again.");
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.logo}>
        <img src="/img/buildyou_logo@3x.png" alt="BuildYou" height="50" />
      </div>
      {errorMessage && <p className={styles.errorMessage}>{errorMessage}</p>}
      <form onSubmit={handleSubmit} className={styles.form}>
        {!inviteCodeFromUrl && (
          <div className={styles.formGroup}>
            <label className={styles.label}>Invite Code:</label>
            <input
              type="text"
              value={inviteCode}
              onChange={(e) => setInviteCode(e.target.value)}
              autoCapitalize="off"
              required
              className={styles.input}
            />
          </div>
        )}
        <div className={styles.formGroup}>
          <label className={styles.label}>Username:</label>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            className={styles.input}
          />
        </div>
        <div className={styles.formGroup}>
          <label className={styles.label}>Password:</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className={styles.input}
          />
        </div>
        <div className={styles.formGroup}>
          <label className={styles.label}>Email:</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            readOnly={!!inviteCodeFromUrl || !!emailFromUrl}
            className={inviteCodeFromUrl || emailFromUrl ? styles.readonlyInput : styles.input}
          />
        </div>
        <button type="submit" className={styles.submitButton}>Register</button>
        <div className={styles.loginContainer}>
          <span>
            Already registered?
            <a href="/login" className={styles.loginLink}>Login</a>
          </span>
        </div>
      </form>
    </div>
  );
};

export default RegisterPage; 